import * as React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { RootState, Dispatch } from '@src/app/_redux';
import { actionCreators as paymentsActionCreators } from '@src/app/accounts/payments/actions';
import { PageOne } from '@src/app/accounts/payments/components/PageOne';
import { PageTwo } from '@src/app/accounts/payments/components/PageTwo';
import { ResponseView } from '@src/app/accounts/payments/components/ResponseView';
import { FormattedMessage, intlShape } from 'react-intl';
import { PaymentsPayload } from '@src/_api/payload/payments';
import { reset } from 'redux-form';
import '../payments.scss';
import { getOrderById, getOrdersForMyOrders } from '@src/app/accounts/redux/selectors';
import { getAdminConfigTableItem } from '@src/app/_global/utility/adminConfigUtils';
import { getLoggedInAddress, getLoggedInCustomer } from '@src/app/accounts/selectors';
import { LoadingView } from '@src/app/_global/components/Loading';
import * as moment from 'moment';
import { CustomOrder } from '@CDSGlobal/gc-backend';
import { withRouter } from 'react-router-dom';
import { ALT_PAY_TYPES } from '@src/app/_global/utility/constants';
import { getAuthorizationCodeFromPaymentCaptureResponse, getAuthorizationDateFromPaymentCaptureResponse, 
         getBillingAgreementIdFromPaymentCaptureResponse, getPresettleIndicatorFromPaymentCaptureResponse, 
         getClientTransactionIdFromPaymentCaptureResponse, translatePaymentCaptureCardTypeToCore, 
         translatePaymentCapturePaymentTypeToCoreAlternatePaymentType, translatePaymentCapturePaymentTypeToCorePaymentType } from '../../payment-methods/paymentUtils';

interface OptInOrders {
  order: CustomOrder;
  checked: boolean;
}
interface State {
  page: number;
  paymentAmount: string;
  selectedOrders: CustomOrder[];
  ordersWithBalance: CustomOrder[];
  displayError: string;
  paymentType: string;
  autoRenewOptIns: OptInOrders[];
  availableActions: any;
}
export interface Props {
  orderList: any;
  currentOrder: any;
  resetForm: any;
  saveAccount: any;
  history: any;
  paymentsStart: (order: any) => void;
  paymentsCancel:  () => void;
  availableActions: any;
  intelliselOffers: any;
  loggedInCustomer: any;
  billToAddress: any;
  paymentsData: any;
  adminConfig: any;
  clientConfig: any;
  directViewLogin: any;
}

export class Form extends React.Component<Props, State> {
  state: State = {
    page: 1,
    paymentAmount: '0',
    selectedOrders: [],
    ordersWithBalance: [],
    displayError: '',
    paymentType: '',
    autoRenewOptIns: [],
    availableActions: {}
  };

  // tslint:disable-next-line:member-ordering
  history: any = this.props.history;

  constructor(props: any, context: any) {
    super(props, context);
    this.nextPage = this.nextPage.bind(this);
    this.previousPage = this.previousPage.bind(this);
    this.onCancel = this.onCancel.bind(this);
    this.changePage = this.changePage.bind(this);
    this.onSubmitPaymentRequest = this.onSubmitPaymentRequest.bind(this);
    this.startOver = this.startOver.bind(this);
    this.onChangePaymentAmount = this.onChangePaymentAmount.bind(this);
    this.onChangePaymentType = this.onChangePaymentType.bind(this);
    this.onChangeSelectedOrders = this.onChangeSelectedOrders.bind(this);
    this.handleAutoRenewCheck = this.handleAutoRenewCheck.bind(this);
  }
  componentDidMount() {
    const { orderList, availableActions  } = this.props;
    let rows = orderList.slice(0);
    let ordersWithBalance;
    let curOrd = this.props.currentOrder;
    if (curOrd) {
      // single order view
      ordersWithBalance = rows.filter((ord) => {return parseFloat(this.calculateOrderBalance(ord)) > 0 && ord.orderNumber === curOrd.orderNumber; }  );
    } else {
      // all orders w/balance
      ordersWithBalance = rows.filter((ord) => {return parseFloat(this.calculateOrderBalance(ord)) > 0; }  );
    }
    let paymentAmount = ordersWithBalance && ordersWithBalance.reduce((tot, ord: CustomOrder) => 
      tot + parseFloat(this.calculateOrderBalance(ord)), 0).toString();

    let displayError = '';
    let ordersWithSameCurrencyCodeAsFirstOrder = ordersWithBalance.filter(order => order.currencyCode === ordersWithBalance[0].currencyCode || order.systemCode !== 'CORE');
    if (ordersWithSameCurrencyCodeAsFirstOrder.length !== ordersWithBalance.length) {
      displayError = 'You can only pay for orders with the same currency in a single payment. Adjust your selection and try again.';
    }

    this.setState({
      paymentAmount: paymentAmount, 
      selectedOrders: ordersWithBalance, 
      ordersWithBalance: ordersWithBalance,
      autoRenewOptIns: [],
      availableActions: availableActions,
      displayError: displayError
    });
  }

  // tslint:disable-next-line:member-ordering
  static contextTypes = {
    intl: intlShape,
  };

  // format table heading labels for i18n
  formatMessage = (messageId, descriptionM, defaultM, context) => {
    const labelText = context.intl.formatMessage({
      id: messageId,
      description: descriptionM,
      defaultMessage: defaultM,
    });
    return labelText;
  }

  calculateOrderBalance(order: CustomOrder) {
    if (order.systemCode === 'SERV') {
      return order.totalOrderValue;
    } else {
      if (order.installmentsAllowed === 'Y') {
        if (parseFloat(order.installmentDue) > 0 ) {
          return order.installmentDue;
        } else {
          return order.amountDue;
        } 
      } else {
        return order.amountDue;
      }
    }
  }
  onCancel() {
    this.props.resetForm();
    this.props.paymentsCancel();
    this.history.push('/accounts/summary');
  }
  handleAutoRenewCheck(evt: React.SyntheticEvent<HTMLInputElement>, order: CustomOrder) {
    let newRenewOptIns = [...this.state.autoRenewOptIns, {order: order, checked: evt.currentTarget.checked}];
    this.setState({ autoRenewOptIns: newRenewOptIns });
  }
  isNewExpireValid(expireMonth: any, expireYear: any) {
    let isValid: boolean = true;
    var today = new Date();
    const now = moment(new Date(today.getFullYear(), today.getMonth()));
    var expDate = new Date(
        parseInt(`20${expireYear}`, 10),
        parseInt(expireMonth, 10) - 1,
    );
    const origExpDate = moment(expDate);
    if (origExpDate.isSameOrBefore(now)) {
      isValid = false;
    }
    return isValid;

  }
  getGoogleAnalyticsCategory(optInCheckedValue: boolean, order: any, ) {
    let gaCat = '';
    if (optInCheckedValue && order.systemCode === 'SERV') {
      if (order.isGift) {
        gaCat = 'Start Gift Auto Renew with Payment';
      } else {
        gaCat = 'Start Auto Renew with Payment';
      }
    } else {
      gaCat = 'Payments';
    }
    return gaCat;
  }
  onSubmitPaymentRequest(response: any) {
    let responseCode = response.pwRespCodee;
    let responseMessage = response.pwRespMessage;
    let payloads: Array<PaymentsPayload> = [];
    let paymentPayload: PaymentsPayload = {
      prodIdAlias: '',
      accountNumber: '',
      amountPaid: '',
      effort: '',
      invoiceNumber: '',
      paymentOnOrderType: '',
      creditCardLastFour: '',
      creditCardExpireMonth: '',
      creditCardExpireYear: '',
      creditCardType: '',
      creditCardNumber: '',
      currencyCode: '',
      systemCode: '',
      autoRenewOptIn: false,
      updatePayMethodOnly: false,
      googleAnalyticsCategory: ''
    };
    if (responseMessage === 'Success' && this.state.selectedOrders.length > 0) {
      let expMM = response.pwResponse.creditCardExpireMonth;
      let expYY = response.pwResponse.creditCardExpireYear;
      let cardType = response.pwResponse.creditCardType;
      let creditCardLastFour = response.pwResponse.creditCardLastFour;
      let cipher = response.pwResponse.token;
      let paymentType = response.pwPaymentType;
      let authCode = response.pwResponse.authCode ? response.pwResponse.authCode : response.pwResponse.authorizationCode;
      this.state.selectedOrders.map((ord: CustomOrder) => {
        let paymentAmount = '0.00';
        let optInCheckedValue = this.state.autoRenewOptIns.find( optIn => 
            optIn.order.orderNumber === ord.orderNumber );
        if (this.state.paymentType === 'totalBalanceDue') {
          // paying total balance of order
          if (ord.systemCode === 'SERV') {
            paymentAmount =   Number( ord.totalOrderValue).toFixed(2);
          } else {
            if (ord.installmentsAllowed === 'Y') {
              if (parseFloat(ord.installmentDue) > 0 ) {
                paymentAmount =   Number(ord.installmentDue).toFixed(2);
              } else {
                paymentAmount =   Number(ord.amountDue).toFixed(2);
              } 
            } else {
              paymentAmount =   Number(ord.amountDue).toFixed(2);
            }
          }
        } else {
          // paying only what is currently due
          if (ord.systemCode === 'SERV') {
            paymentAmount =   Number( ord.amountDue).toFixed(2);
          } else {
            let orderBalance = this.calculateOrderBalance(ord);
            if ((parseFloat(ord.installmentAmount) < parseFloat(orderBalance)) && ((parseFloat(ord.installmentAmount) > 0))) {
              paymentAmount =   Number(ord.installmentAmount).toFixed(2);
            } else {
              paymentAmount =   Number(ord.amountDue).toFixed(2);
            }     
          }
        }
        let optInValue =  optInCheckedValue ? optInCheckedValue.checked : false;
        switch (ord.systemCode) {
          case 'SERV':
            paymentPayload = {
              prodIdAlias: ord.prodIdAlias,
              accountNumber: ord.billToAccountNumber,
              amountPaid: paymentAmount,
              effort: 'I',
              invoiceNumber: ord.orderNumber,
              paymentOnOrderType: ord.isGift ? 'GIFT' : 'REG',
              creditCardExpireMonth: expMM,
              creditCardExpireYear: expYY,
              creditCardType: cardType,
              creditCardNumber: cipher,
              creditCardLastFour: creditCardLastFour,
              systemCode: ord.systemCode,
              autoRenewOptIn: optInValue,
              paymentType: 'creditcard',  
              authCode: authCode,
              googleAnalyticsCategory: this.getGoogleAnalyticsCategory(optInValue, ord),
            };
            if (paymentType in ALT_PAY_TYPES) {
              // tslint:disable-next-line:no-string-literal
              paymentPayload['altPayInfo'] = ALT_PAY_TYPES[paymentType];
            }
            payloads.push(paymentPayload, );
            break;
          case 'SERVPF':
            if (ord.isGift) {
              let isFirstItem = true;
              ord.orderItems.forEach(orderItem => {
                
                paymentPayload = {
                  prodIdAlias: ord.prodIdAlias,
                  accountNumber: ord.billToAccountNumber,
                  invoiceNumber: ord.invoiceNumber ? ord.invoiceNumber : '',
                  amountPaid: paymentAmount,
                  paymentType: 'creditcard',  
                  effort: '01',
                  redeemPremium: 'N',
                  creditCardExpireMonth: expMM,
                  creditCardExpireYear: expYY,
                  creditCardType: cardType,
                  creditCardNumber: cipher,
                  creditCardLastFour: creditCardLastFour,
                  systemCode: ord.systemCode,
                  planCode: ord.planCode ? ord.planCode : '',
                  updateType: 'updatePayMethod',
                  orderType: cipher ? 'C' : 'B',
                  autoRenewOptIn: optInValue,
                  authCode: authCode,
                  updatePayMethodOnly: isFirstItem === false ?  true : false,
                  recipAccountNumber:  orderItem.isRecipient ?  orderItem.shipToAccountNumber : '',
                  shipFrequency: orderItem.frequency,
                  googleAnalyticsCategory: this.getGoogleAnalyticsCategory(optInValue, ord),
                };
                if (paymentType in ALT_PAY_TYPES) {
                  // tslint:disable-next-line:no-string-literal
                  paymentPayload['altPayInfo'] = ALT_PAY_TYPES[paymentType];
                }
                payloads.push(paymentPayload, );
                isFirstItem = false;
              });
            } else {
              paymentPayload = {
                prodIdAlias: ord.prodIdAlias,
                accountNumber: ord.billToAccountNumber,
                invoiceNumber: ord.invoiceNumber ? ord.invoiceNumber : '',
                amountPaid: paymentAmount,
                paymentType: 'creditcard', 
                effort: '01',
                redeemPremium: 'N',
                creditCardExpireMonth: expMM,
                creditCardExpireYear: expYY,
                creditCardType: cardType,
                creditCardNumber: cipher,
                creditCardLastFour: creditCardLastFour,
                systemCode: ord.systemCode,
                planCode: ord.planCode ? ord.planCode : '',
                updateType: 'updatePayMethod',
                orderType: cipher ? 'C' : 'B',
                autoRenewOptIn: optInValue,
                updatePayMethodOnly: false,
                recipAccountNumber: '',
                shipFrequency: ord.frequency,
                authCode: authCode,
                googleAnalyticsCategory: this.getGoogleAnalyticsCategory(optInValue, ord),
              };
              if (paymentType in ALT_PAY_TYPES) {
                // tslint:disable-next-line:no-string-literal
                paymentPayload['altPayInfo'] = ALT_PAY_TYPES[paymentType];
              }
              payloads.push(paymentPayload, );
            }
            break;
          case 'CORE':
            // All invoices go in one payment tranaction for Core, so if we have already
            // created one, just add the invoice number and amount paid. The total payment
            // amount is already loaded into the transaction.
            let corePayload = payloads.find( payload => payload.systemCode === 'CORE');

            if (corePayload) {
              corePayload.invoiceNumbers?.push(ord.invoiceNumber || ord.orderNumber);
              corePayload.invoiceAmountPaid.push({invoiceNumber: ord.invoiceNumber || ord.orderNumber, amountPaid: paymentAmount});
              if (optInValue) {
                this.addEntityIds(optInCheckedValue, corePayload, ord);
              }
            } else {
              paymentPayload = {
                prodIdAlias: this.props.loggedInCustomer.prodIdAlias,
                accountNumber: ord.billToAccountNumber,
                amountPaid: this.state.paymentAmount,
                effort: '',
                invoiceNumber: '',
                invoiceNumbers: [ord.invoiceNumber || ord.orderNumber],
                invoiceAmountPaid: [{invoiceNumber: ord.invoiceNumber || ord.orderNumber, amountPaid: paymentAmount}],
                creditCardExpireMonth: expMM,
                creditCardExpireYear: expYY,
                creditCardType: translatePaymentCaptureCardTypeToCore(cardType),
                creditCardNumber: cipher,
                creditCardLastFour: creditCardLastFour,
                currencyCode: ord.currencyCode,
                systemCode: ord.systemCode,
                paymentType: translatePaymentCapturePaymentTypeToCorePaymentType(paymentType),
                clientTransactionId: getClientTransactionIdFromPaymentCaptureResponse(response),
                authorizationCode: getAuthorizationCodeFromPaymentCaptureResponse(response),
                authorizationDate: getAuthorizationDateFromPaymentCaptureResponse(response),
                presettleIndicator: getPresettleIndicatorFromPaymentCaptureResponse(response),
                googleAnalyticsCategory: this.getGoogleAnalyticsCategory(optInValue, ord),
                googleAnalyticsLabel: ord.prodIdAlias,
                entityIds: [],
              };
              if (optInValue) {
                  this.addEntityIds(optInCheckedValue, paymentPayload, ord);
              }
              if (paymentType in ALT_PAY_TYPES) {
                if (paymentType === 'AP') {
                  paymentPayload.digitalPaymentType = 'Apple Pay';
                } else {
                  paymentPayload.alternatePaymentType = translatePaymentCapturePaymentTypeToCoreAlternatePaymentType(paymentType);
                  paymentPayload.billingAgreementId = getBillingAgreementIdFromPaymentCaptureResponse(response);
                }
              }
              payloads.push(paymentPayload, );
            }
            break;
          default: 
            break;
        }
      });
        this.props.paymentsStart({paymentsPayloads: payloads});
        this.setState({ page: 3 }); 
    } else {
      console.log('GC-PC Payment Error: responseCode' + responseCode );
      this.setState({ page: 2, displayError: 'Please retry your transaction', }); 
    }
  }
  addEntityIds(optInCheckedValue: OptInOrders | undefined, corePayload: PaymentsPayload, ord: CustomOrder) {
    if (optInCheckedValue?.order.entityType && optInCheckedValue?.order.entityType !== 'product') {
      corePayload.entityIds.push({entityId: optInCheckedValue?.order.entityId, 
                                  entityType: optInCheckedValue?.order.entityType,
                                  googleAnalyticsLabel: ord.prodIdAlias 
                                });
    } else if (optInCheckedValue?.order.entityType && optInCheckedValue?.order.entityType === 'product') {
      if (optInCheckedValue?.order.orderItems.length > 0) {
        optInCheckedValue?.order.orderItems.forEach(item => {
          if (item.entityType === 'membership' || item.entityType === 'publication' || item.entityType === 'series') {
            corePayload.entityIds.push({entityId: item.entityId, 
                                        entityType: item.entityType,
                                        googleAnalyticsLabel: ord.prodIdAlias 
                                      });
          }
        });

      }
    }
  }
  changePage(pageNum: number) {
    if (pageNum < this.state.page) {
      this.setState({ page: pageNum });
    }
  }
  onChangePaymentType(paymentType: string)  {
    this.setState({paymentType: paymentType});
  }

  onChangePaymentAmount(paymentAmount: string)  {
    this.setState({paymentAmount: paymentAmount});
  }
  onChangeSelectedOrders(newSelectedOrders: CustomOrder[])  {
    if (newSelectedOrders.length === 0 ) {
      let newPaymentAmount = newSelectedOrders && newSelectedOrders.reduce((tot, ord) => tot + parseFloat(ord.totalOrderValue), 0).toString();
      this.setState({displayError: 'You must select at least one order to pay.', selectedOrders: newSelectedOrders, paymentAmount: newPaymentAmount});
    } else if (newSelectedOrders.length > 1) {
      let newPaymentAmount = newSelectedOrders && newSelectedOrders.reduce((tot, ord) => tot + parseFloat(ord.totalOrderValue), 0).toString();
      let ordersWithSameCurrencyCodeAsFirstOrder = newSelectedOrders.filter(order => order.currencyCode === newSelectedOrders[0].currencyCode || order.systemCode !== 'CORE');
      if (ordersWithSameCurrencyCodeAsFirstOrder.length !== newSelectedOrders.length) {
        this.setState({displayError: 'You can only pay for orders with the same currency in a single payment. Adjust your selection and try again.', 
                        selectedOrders: newSelectedOrders, paymentAmount: newPaymentAmount});
      } else {
        this.setState({displayError: '', selectedOrders: newSelectedOrders, paymentAmount: newPaymentAmount});
      }
    } else {
      let newPaymentAmount = newSelectedOrders && newSelectedOrders.reduce((tot, ord) => tot + parseFloat(this.calculateOrderBalance(ord)), 0).toString();
      this.setState({displayError: '', selectedOrders: newSelectedOrders, paymentAmount: newPaymentAmount});
    }

  }
  nextPage() {
    this.setState({ page: this.state.page + 1 });
  }

  previousPage() {
    this.setState({ page: this.state.page - 1 });
  }

  startOver() {
    this.props.resetForm();
    this.setState({ page: 1 });
  }

  render() {
    const { page } = this.state;
    return (
      <div>

      <section className="payments-ct">
      
        <header className="page-header change-account-header">
          <FormattedMessage
            id="payment.title"
            description="Make a Payment"
            defaultMessage="Make a Payment"
          />

        </header>
        { this.props.paymentsData.loading ? (
          <div>
          <LoadingView loadingText="Loading..."/>
          </div>
        ) : (
          <div className="payment-wizard">
            {page === 1 &&  (
              <PageOne
                {...this.props}
                onSubmit={this.nextPage}
                onChangePaymentAmount={this.onChangePaymentAmount}
                onChangePaymentType={this.onChangePaymentType}
                onChangeSelectedOrders={this.onChangeSelectedOrders}
                paymentAmount={this.state.paymentAmount}
                selectedOrders={this.state.selectedOrders}
                ordersWithBalance={this.state.ordersWithBalance}
                displayError={this.state.displayError}
                handleAutoRenewCheck={this.handleAutoRenewCheck}
                onCancel={this.onCancel}
                directViewLogin={this.props.directViewLogin}
              />
            )}
            {page === 2 &&  (
              <PageTwo
                {...this.props}
                previousPage={this.previousPage}
                onCancel={this.onCancel}
                paymentAmount={this.state.paymentAmount}
                selectedOrders={this.state.selectedOrders}
                history={this.props.history}
                displayError={this.state.displayError} 
                billToAddress={this.props.billToAddress}
                submitPaymentHandler={this.onSubmitPaymentRequest}
                paymentsData={this.props.paymentsData}
                directViewLogin={this.props.directViewLogin}
                loggedInCustomer={this.props.loggedInCustomer}
              />
            )}
            {page === 3 && (
              <ResponseView
                {...this.props}
                result={this.props.paymentsData.paymentsResult}
                onCancel={this.onCancel}
                paymentAmount={this.state.paymentAmount}
                selectedOrders={this.state.selectedOrders}
                intelliselOffers={this.props.intelliselOffers}
                adminConfig={this.props.adminConfig}
                clientConfig={this.props.clientConfig}
                billToAddress={this.props.billToAddress}
                directViewLogin={this.props.directViewLogin}
              />
            )}
          </div>
        )}
      </section>
      </div>
    );
  }
}

const mapStateToProps = (state: RootState, props) => {
  const currentOrder = getOrderById(state, props.match.params.orderNumber);
  const prodIdAlias = currentOrder ? currentOrder.prodIdAlias : '';
  return {
    orderList: getOrdersForMyOrders(state),
    currentOrder: currentOrder,
    loggedInCustomer: getLoggedInCustomer(state),
    billToAddress: getLoggedInAddress(state),
    paymentsData: state.account.paymentsData,
    intelliselOffers: getAdminConfigTableItem(
      state.adminConfig,
      state.clientConfig,
      'UpsellOffers',
      prodIdAlias
    ),
    availableActions: getAdminConfigTableItem(
      state.adminConfig,
      state.clientConfig,
      'AvailableActions',
      prodIdAlias
    ),
    adminConfig: state.adminConfig,
    clientConfig: state.clientConfig,
    directViewLogin: state.userState.directViewLogin,
  };
};

const mapDispatchToProps = (dispatch: Dispatch) =>
  bindActionCreators(
    {
      paymentsStart: paymentsActionCreators.paymentsStart,
      paymentsCancel: paymentsActionCreators.paymentsCancel,
      resetForm: () => dispatch(reset('replacement-payment')),
    },
    dispatch,
  );

export const Payments = withRouter(connect(
  mapStateToProps,
  mapDispatchToProps,
)(Form));
